import { Slide } from "react-reveal";
const google =
  "https://res.cloudinary.com/malidad/image/upload/v1777959271/ntuna/google_th0rxv.svg";
const star =
  "https://res.cloudinary.com/malidad/image/upload/v1777961231/4star_uflegw.svg";
const fb =
  "https://res.cloudinary.com/malidad/image/upload/v1777962168/facebook-square-icon_a32wly.svg";
const ig =
  "https://res.cloudinary.com/malidad/image/upload/v1777962169/insta_rollxq.svg";
const tw =
  "https://res.cloudinary.com/malidad/image/upload/v1777962174/x-social-media-logo-icon_cvr5sq.svg";
const ln =
  "https://res.cloudinary.com/malidad/image/upload/v1777962177/linkedin-app-icon_urola3.svg";
const Footer = () => {
  return (
    <footer
      className="footer ntuna-dark-bg section-spacing-24 no-padding-bottom"
      role="contentinfo"
    >
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="footer-items-container flex">
              <div className="footer-about-side">
                <div className="footer-brand flex">
                  <img
                    src="https://res.cloudinary.com/malidad/image/upload/v1779680532/ntuna_2026_logo_36_c8hccz.png"
                    alt="NTUNA.COM Logo"
                  />
                  <p className="ntuna-text-fill boldTitle">
                    NTUNA.COM<sup>&trade;</sup>
                  </p>
                </div>
                <p>
                  Powering progress and efficiency using technology for modern
                  organizations and growing businesses since 2017.
                </p>
              </div>
              <div className="footer-menus-side">
                <ul className="footer-menus-container flex">
                  <li className="footer-menu-item">
                    <h3 className="footer-menu-title">Quick Links</h3>
                    <ul>
                      <li>
                        <a href="/" rel="noopener noreferrer">
                          Home
                        </a>
                      </li>
                      <li>
                        <a href="/clients" rel="noopener noreferrer">
                          Clients
                        </a>
                      </li>
                      <li>
                        <a href="/solutions" rel="noopener noreferrer">
                          Solutions
                        </a>
                      </li>

                      <li>
                        <a
                          href="https://form.jotform.com/ntuna/get-free-quote"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Get Free Quote
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://form.jotform.com/ntuna/get-free-quote"
                          rel="noopener noreferrer"
                        >
                          Book Free Consultation
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className="footer-menu-item">
                    <h3 className="footer-menu-title">Company</h3>
                    <ul>
                      <li>
                        <a href="/about" rel="noopener noreferrer">
                          About
                        </a>
                      </li>
                      <li>
                        <a href="/careers" rel="noopener noreferrer">
                          Careers
                        </a>
                      </li>
                      <li>
                        <a href="/industries" rel="noopener noreferrer">
                          Industries
                        </a>
                      </li>

                      <li>
                        <a href="/contacts" rel="noopener noreferrer">
                          Contact Us
                        </a>
                      </li>
                      <li>
                        <a href="/why-choose-ntuna" rel="noopener noreferrer">
                          Why Choose Us
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className="footer-menu-item">
                    <h3 className="footer-menu-title">Resources</h3>
                    <ul>
                      <li>
                        <a
                          href="/frequently-asked-questions"
                          rel="noopener noreferrer"
                        >
                          FAQs
                        </a>
                      </li>
                      <li>
                        <a href="/blog" rel="noopener noreferrer">
                          Blog/Insights
                        </a>
                      </li>
                      <li>
                        <a href="/case-studies" rel="noopener noreferrer">
                          Case Studies
                        </a>
                      </li>
                      <li>
                        <a href="/privacy-policy" rel="noopener noreferrer">
                          Privacy Policy
                        </a>
                      </li>
                      <li>
                        <a href="/#" rel="noopener noreferrer">
                          Offers &amp; Discounts
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>

            <div className="footer-address-strip flex">
              <div className="footer-review footer-strip-item">
                <Slide top>
                  <div className="section-head-rate-item google">
                    <a href="/#" rel="noopener noreferrer">
                      <img src={google} alt="Ntuna.com's Google Reviews" />{" "}
                      <div>
                        <div className="flex google-review">
                          <span className="boldTitle rate-average ntuna-dark">
                            4.9
                          </span>
                          <div className="rate-stars-container">
                            <img
                              src={star}
                              alt="4.9 Star"
                              className="rate-star"
                            />
                          </div>
                        </div>
                        <span className="uppercase rate-label">
                          customer reviews
                        </span>
                      </div>
                    </a>
                  </div>
                </Slide>
              </div>
              <div className="footer-address footer-strip-item">
                <p>
                  <a
                    href="https://wa.me/256702096666"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Buganda Road, Kampala
                  </a>
                </p>
                <p>
                  <a
                    href="https://wa.me/13153470333"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    42 Syracuse Ave, New York
                  </a>
                </p>
                <p className="hide">
                  <a
                    href="https://wa.me/13153470333"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    500 Jorrison Street, Pretoria
                  </a>
                </p>
              </div>
              <div className="footer-contacts footer-strip-item">
                <p>
                  <a href="tel:+256702096666">+256-702-096-666</a>
                </p>
                <p>
                  <a href="tel:+13153470333">+1-315-347-0333</a>
                </p>
                <p className="hide">
                  <a href="tel:+256771001999">+256-771-001-999</a>
                </p>
              </div>
              <ul className="footer-socials footer-strip-item flex">
                <li>
                  <a
                    href="https://facebook.com/ntunacom"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={fb} alt="Facebook logo icon" />
                    <p>Facebook</p>
                  </a>
                </li>
                <li>
                  <a
                    href="https://x.com/ntuna_com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={tw} alt="Twitter/X logo icon" />
                    <p>X/Twitter</p>
                  </a>
                </li>
                <li>
                  <a
                    href="https://linkedin.com/company/ntunacom"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={ln} alt="Linkedin logo icon" />
                    <p>Linkedin</p>
                  </a>
                </li>
                <li>
                  <a
                    href="https://instagram.com/ntunacom"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={ig} alt="Instagram logo icon" />
                    <p>Instagram</p>
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-copyright-strip ntuna-dark-secondary center padding-24">
              <p>
                &copy; 2017-{new Date().getFullYear()} NTUNA.COM, All Rights
                Reserved
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
